import React from 'react';
import { FilterIcon } from '../Icons/Icons';
import './SearchResultsHeader.css';

function SearchResultsHeader({ totalResults, filters, onFilterTagRemove, onMobileFiltersOpen }) {
  const getActiveFilters = () => {
    const active = [];

    if (filters.cities?.length > 0) {
      filters.cities.forEach(city => {
        active.push({ type: 'city', value: city, label: city });
      });
    }

    if (filters.propertyTypes?.length > 0) {
      filters.propertyTypes.forEach(type => {
        active.push({ type: 'propertyType', value: type, label: type });
      });
    }

    if (filters.priceMin || filters.priceMax) {
      const label = `${filters.priceMin || 'Any'} - ${filters.priceMax || 'Any'}`;
      active.push({ type: 'price', value: 'price', label });
    }

    if (filters.areaMin || filters.areaMax) {
      const label = `${filters.areaMin || 'Any'} - ${filters.areaMax || 'Any'}`;
      active.push({ type: 'area', value: 'area', label });
    }

    if (filters.beds) {
      active.push({ type: 'beds', value: filters.beds, label: `${filters.beds} Beds` });
    }

    if (filters.baths) {
      active.push({ type: 'baths', value: filters.baths, label: `${filters.baths} Baths` });
    }

    return active;
  };

  const activeFilters = getActiveFilters();

  return (
    <div className="search-results-header">
      <div className="results-info">
        <h1 className="results-title">
          Properties for Sale
        </h1>
        <p className="results-count">
          {totalResults.toLocaleString()} properties found
        </p>
      </div>

      {activeFilters.length > 0 && (
        <div className="active-filters">
          <div className="filter-tags">
            {activeFilters.map((filter, index) => (
              <div key={`${filter.type}-${filter.value}-${index}`} className="filter-tag">
                <span>{filter.label}</span>
                <button
                  className="remove-filter"
                  onClick={() => onFilterTagRemove(filter.type, filter.value)}
                >
                  ×
                </button>
              </div>
            ))}
          </div>
          <button className="btn-clear-all" onClick={() => onFilterTagRemove('all')}>
            Clear All
          </button>
        </div>
      )}

      <button className="btn-mobile-filters" onClick={onMobileFiltersOpen}>
        <span className="filter-icon">
          <FilterIcon size={20} color="currentColor" />
        </span>
        <span>Filters</span>
        {activeFilters.length > 0 && (
          <span className="filter-count">{activeFilters.length}</span>
        )}
      </button>
    </div>
  );
}

export default SearchResultsHeader;
